module.exports = __webpack_public_path__ + "img/im_tabledressing@2x.f761dc64.jpg";